import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { firebaseConfig } from "./config";
import { deleteObject, getStorage } from "firebase/storage";
import { v4 as uuidv4 } from 'uuid';
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
// const analytics = getAnalytics(app);

// Uploads a file to Cloud Storage.
export function uploadImageWithPromise(file: File, path: string): Promise<Object> {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}/${currentDate.getMonth() + 1}/${currentDate.getDate()}/`;

    return new Promise(async (resolve, reject) => {
        try {
            var path_image_firebase = `${path}${formattedDate}${uuidv4()}`;
            const storageRef = ref(storage, path_image_firebase);
            const snapshot = await uploadBytes(storageRef, file);
            console.log('Uploaded a blob or file!', snapshot);

            const image_url = await getDownloadURL(snapshot.ref);
            console.log('File available at', image_url);

            const result = { path_image_firebase, image_url };
            resolve(result);

        } catch (error) {
            console.error('Error uploading image:', error);
            reject(error);
        }
    });
}

// Remove the 'image' in Cloud Storage.
export async function removeImage(path: string) {
    const imageRef = ref(storage, path);
    try {
        await deleteObject(imageRef);
        console.log(`Image at ${path} has been successfully deleted.`);
    } catch (error) {
        console.error(`Error deleting image at ${path}: ${error}`);
    }
}




